// Gates the Meta and TikTok Pixels behind an accept/decline choice, stored so
// we don't ask again. Nothing here runs before a choice is made – no cookie,
// no pixel – because that's the whole point of asking first.
(function () {
    const STORAGE_KEY = 'cookieConsent';
    const banner = document.getElementById('cookie-consent');
    if (!banner) return;

    const loadPixels = () => {
        window.__loadFbPixel?.();
        window.__loadTtPixel?.();
    };

    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'accepted') {
        loadPixels();
        return;
    }
    if (stored === 'declined') return;

    banner.hidden = false;

    document.getElementById('cc-accept')?.addEventListener('click', () => {
        localStorage.setItem(STORAGE_KEY, 'accepted');
        banner.hidden = true;
        loadPixels();
    });

    document.getElementById('cc-decline')?.addEventListener('click', () => {
        localStorage.setItem(STORAGE_KEY, 'declined');
        banner.hidden = true;
    });
})();
